import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationBody } from "../util/build-authentication-body";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";
import { UpdateSourceNameTypes } from "@src/cloud-connect/use-cases/update-source-name";

export const putsUpdateSourceName = async (dto: UpdateSourceNameTypes) => {
  try {
    const res = await fetch(`${appUrl()}/api/update-source-name`, {
      method: "POST",
      headers: buildAuthenticationHeaders(),
      body: JSON.stringify({
        ...buildAuthenticationBody(),
        name: dto.name,
        source_id: dto.source_id,
        source_type: dto.source_type,
      }),
    });

    return { success: res.ok };
  } catch (err) {
    if (err instanceof TokensExpiredError) {
      navigateTo(Route.TOKENS_EXPIRED_ERROR);
    } else {
      return { success: false };
    }
  }
};
